/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { AccountContext, withAccount } from '../../../components/AccountContext';
import { growlErrors } from '../../../utils/NotificationUtil';
import { searchSurveyTemp } from '../../../services/apps/SurveyTemplateService';
import { createExecutiveReport } from '../../../services/apps/ExecutiveReportService';
import { NotificationContext, withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';
import { validationMessages } from '../../../i18n/common';
import { renderAsyncSelector } from '../../../components/formik-components/FormAsyncSelector';
import { dropDownNormalizer } from '../../../utils/NomalizeUtil';
import { LegacyInputTextComponent } from '../../../components/prime-formik';
import useSubscriptionExpiredRestrictions from '../../../hooks/useSubscriptionExpiredRestrictions';

const i18n = defineMessages({
  namePlaceholder: { id: 'name', defaultMessage: 'Name' },
  choose: { id: 'choose', defaultMessage: 'Choose' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  create: { id: 'actions.save', defaultMessage: 'Save' },
});

const NewExecReportContainer = () => {
  const [loading, setLoading] = useState(false);
  const [surveyTemplates, setSurveyTemplates] = useState([]);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const history = useHistory();
  const { formatMessage } = useIntl();
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const getTemplate = async (query) => {
    setLoading(true);

    try {
      const result = await searchSurveyTemp({
        aid: currentAccount,
        query,
      });

      setSurveyTemplates(result);
    } catch (err) {
      growlErrors(growl, err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTemplate();
  }, []);

  const onCancel = () => {
    history.push(`/accounts/${currentAccount}/executive-reports`);
  };

  const searchTemp = (query) => {
    getTemplate(query);
  };

  const handleonSave = async (formValues) => {
    const { managerTeamName, assessmentTemplate } = formValues;
    try {
      const result = await createExecutiveReport({
        accountId: currentAccount,
        teamName: managerTeamName,
        templateId: assessmentTemplate.id,
      });
      const { id } = result.createExecutiveReport;
      const importURL = `/accounts/${currentAccount}/executive-reports/${id}/import`;

      history.push(importURL);
    } catch (graphqlResponse) {
      growlErrors(growl, graphqlResponse);
    }
  };

  const initialValues = { managerTeamName: '' };
  const validationSchema = Yup.object().shape({
    managerTeamName: Yup.string().required(formatMessage(validationMessages.required)),
  });

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <div className="p-grid">
            <div className="p-col-6">
              <Formik onSubmit={handleonSave} initialValues={initialValues} validationSchema={validationSchema}>
                {({ isSubmitting, setFieldValue }) => {
                  return (
                    <Form>
                      <Panel header={<FormattedMessage id="exec_report.new" defaultMessage="New Executive Report" />}>
                        <div className="p-grid p-fluid">
                          <div className="p-col-12">
                            <div className="{{if errors.name 'has-error'}}">
                              <label className="field-label" htmlFor="report-name">
                                <FormattedMessage id="lbl.exec_mng_team_name" defaultMessage="Management Team Name" />
                              </label>
                              <Field
                                id="managerTeamName"
                                type="text"
                                name="managerTeamName"
                                component={LegacyInputTextComponent}
                                placeholder={formatMessage(i18n.namePlaceholder)}
                              />
                            </div>
                          </div>
                          <div className="p-col-12">
                            <label className="field-label" htmlFor="assessmentTemplate">
                              <FormattedMessage id="survey-template" defaultMessage="Survey Template" />
                            </label>
                            <Field
                              id="assessmentTemplate"
                              name="assessmentTemplate"
                              component={renderAsyncSelector}
                              data={surveyTemplates}
                              valueField="id"
                              onSearch={searchTemp}
                              processing={loading}
                              normalize={(data) => dropDownNormalizer(data, 'id')}
                              textField="title"
                              placeholder={`- ${formatMessage(i18n.choose)} -`}
                              setFieldValue={setFieldValue}
                              filter
                            />
                          </div>
                        </div>
                        <div className="p-grid">
                          <div className="p-col-12">
                            <Button
                              type="button"
                              className="p-button-secondary"
                              label={formatMessage(i18n.cancel)}
                              onClick={onCancel}
                            />
                            <Button
                              type="submit"
                              icon={isSubmitting ? 'pi pi-spin pi-spinner' : ''}
                              disabled={isSubmitting || subscriptionIsExpired}
                              label={formatMessage(i18n.create)}
                            />
                          </div>
                        </div>
                      </Panel>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewExecReportContainer;
